<template>
  <el-dialog
    :visible.sync="showtag"
    class="basic_atlas_catalog_pc_look"
    width="100%"
    :append-to-body="$store.state.app.view_pattern === 'pc' ? true : false"
    :modal="$store.state.app.view_pattern === 'pc' ? true : false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :fullscreen="true"
  >
    <div class="look_frame">
      <i class="iconfont icon-chuyidong close_look" @click="close_look"></i>

      <div class="look_swiper">
        <swiper
          ref="mySwiper"
          class="basic_atlas_catalog_swiper"
          :options="swiperOption"
          v-if="!go_on_look_isShow"
        >
          <swiper-slide v-for="(item,i) in imgs" :key="i">
            <div class="back_img">
              <img :src="item.img_path" />
              <p
                v-if="$store.state.app.view_pattern === 'pc' && item.summary"
              >{{item.summary}}</p>
            </div>
            <p
              class="mb_title"
              v-if="$store.state.app.view_pattern === 'mb' && item.summary"
            >{{item.summary}}</p>
          </swiper-slide>
        </swiper>
        <template v-if="!go_on_look_isShow && $store.state.app.view_pattern === 'pc'">
          <div class="look_swiper_arrow look_swiper_prev fa fa-angle-left" @click="swiper_prev"></div>
          <div class="look_swiper_arrow look_swiper_next fa fa-angle-right" @click="swiper_next"></div>
        </template>
      </div>

      <go_on_look
        v-if="go_on_look_isShow"
        :go_on_list="go_on_list"
        @re_select="re_select"
        @go_on_look_closed="go_on_look_closed"
      ></go_on_look>

      <div class="photo_list_frame">
        <ul class="photo_list" v-if="$store.state.app.view_pattern === 'pc'">
          <li
            v-for="(item,i) in imgs"
            :key="i"
            class="one_li"
            :style="{backgroundImage:'url(' + item.img_path + ')'}"
            @click="swiper_change(i)"
            :class="index == i ? 'select' : ''"
          ></li>
        </ul>
      </div>
    </div>
  </el-dialog>
</template>

<script type="text/javascript">
import i18n from '../../language/index'

import go_on_look from "./go_on_look";
export default {
  name: "app",
  data () {
    return {
      showtag: true,
      go_on_look_isShow: false,
      road_type:this.$store.state.app.road_type,
      view_pattern:this.$store.state.app.view_pattern,
      swiperOption: {
        myVm: this,
        loop: false,
        direction: "horizontal",
        effect: "fade",
        on: {
          slideChange: function (e) {
            const that = this.passedParams.myVm;
            that.index = this.activeIndex;
          },
          init: function () {
            const that = this.passedParams.myVm;
            that.index = 0;
          },
          reachEnd: function () { },
          touchEnd: function (e) {
            const that = this.passedParams.myVm;
            // 判断是否打开继续浏览
            if (that.index == that.imgs.length - 1) {
              if(that.road_type == 1 && that.view_pattern == 'mb'){
                return

              }
              that.go_on_look_isShow = true;
            }
          }
        }
      },
      index: 0,
      now_item: this.select_atlas
    };
  },
  props: {
    all_list: {
      type: Array,
      default: function () {
        return [];
      }
    },
    select_atlas: {
      type: Object,
      default: null
    }
  },
  methods: {
    swiper_change (i) {
      this.$refs.mySwiper.swiper.slideTo(i, 200, false);
      this.index = i;
      //如果按钮过多，超过屏幕宽度，则需要做自然滚动
      this.btn_scroll(i);
    },
    btn_scroll (i) {
      const frame = $(".basic_atlas_catalog_pc_look").find(".photo_list_frame");
      const parent_w = frame.width();
      const child_w = frame.children(".photo_list").width();
      if (child_w > parent_w) {
        const end_offset = frame.find(".one_li").outerWidth(true) * i;
        const left = (parent_w - 110) / 2;
        frame.animate(
          {
            scrollLeft: `${end_offset - left}px`
          },
          200
        );
      }
    },
    swiper_prev () {
      this.$refs.mySwiper.swiper.slidePrev();
    },
    swiper_next () {
      // 判断是否打开继续浏览
      if (this.index == this.imgs.length - 1) {
        this.go_on_look_isShow = true;
        return;
      }

      this.$refs.mySwiper.swiper.slideNext();
    },
    data_init () {
      let obj = {
        imgs: [],
        go_on_list: []
      };
      const atlas_look = this.$store.state.atlas_look;
      if (atlas_look.now_item) {
        const s_id = atlas_look.now_item.id;
        let index = 0;

        for (let i = 0; i < atlas_look.all_list.length; i++) {
          if (s_id == atlas_look.all_list[i].id) {
            index = i;
            obj.imgs = atlas_look.all_list[i].lists;

            if (index == atlas_look.all_list.length - 1) {
              obj.go_on_list = [
                atlas_look.all_list[atlas_look.all_list.length - 1]
              ];
            } else {
              obj.go_on_list = atlas_look.all_list.slice(index + 1);
            }
            break;
          }
        }
      }
      return obj;
    },
    re_select (item) {
      this.$store.commit("atlas_look/SET_now_item", item);
      this.go_on_look_closed();
    },
    go_on_look_closed () {
      this.go_on_look_isShow = false;
    },
    close_look () {
      this.$store.commit("atlas_look/SET_is_Show", false);
      this.$store.commit("atlas_look/SET_now_item", null);
      this.$store.commit("atlas_look/SET_all_list", []);
    }
  },
  computed: {
    imgs () {
      const imgs = this.data_init().imgs;
      console.log("imgs");
      return imgs;
    },
    go_on_list () {
      const go_on_list = this.data_init().go_on_list;
      console.log("go_on_list");
      return go_on_list;
    }
  },
  created () { },
  mounted () { },
  components: {
    go_on_look
  }
};
</script>

<style lang="scss" scoped>
.basic_atlas_catalog_pc_look {
  /deep/ .el-dialog__header {
    display: none;
  }
  /deep/ .el-dialog {
    background: rgba(0, 0, 0, 0.5);
    .el-dialog__body {
      padding: 0;
      width: 100%;
      height: 100%;
      position: relative;
      .look_frame {
        width: 100%;
        height: 100%;
        position: fixed;
        z-index: 99999;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 30px 80px 140px 80px;
        .close_look {
          display: inline-block;
          position: absolute;
          top: 20px;
          right: 20px;
          font-size: 26px;
          cursor: pointer;          
          color: #666;
          z-index: 999;
          background-color: #fff;
          border-radius: 50px;
          width: 50px;
          height: 50px;
          line-height: 50px;
          text-align: center;
        }
        .look_swiper {
          height: 100%;
          position: relative;
          .basic_atlas_catalog_swiper {
            height: 100%;
            .swiper-slide {
              width: 100%;
              height: 100%;
              position: relative;
              opacity: 0 !important;
              background: transparent;

              .back_img {
                border-radius: 5px;
                overflow: hidden;
                width: 100%;
                height: 100%;
                position: relative;

                img {
                  display: block;
                  margin: 0 auto;
                  max-width: 100%;
                  max-height: 100%;
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                }
                p {
                  background: #fff;
                  padding: 14px 20px 18px 20px;
                }
              }
            }
            .swiper-slide-active {
              opacity: 1 !important;
              .back_img {
              }
            }
          }
        }
        .photo_list_frame {
          position: absolute;
          left: 0;
          bottom: 20px;
          width: 100%;
          font-size: 0;
          text-align: center;
          display: flex;
          overflow-y: hidden;
          overflow-x: auto;
          padding-top: 10px;
          .photo_list {
            white-space: nowrap;
            margin: 0 auto;
            li {
              cursor: pointer;
              display: inline-block;
              width: 110px;
              height: 80px;
              margin-left: 8px;
              margin-right: 7px;
              background-position: center;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              position: relative;
            }
            li:before {
              content: "";
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              border: 2px solid #fff;
              opacity: 0;
              -webkit-transition: opacity 0.3s;
              -o-transition: opacity 0.3s;
              -moz-transition: opacity 0.3s;
              transition: opacity 0.3s;
            }
            li:hover {
              -webkit-transform: scale(1.1);
              -moz-transform: scale(1.1);
              -ms-transform: scale(1.1);
              -o-transform: scale(1.1);
              transform: scale(1.1);
              -webkit-transform-origin: bottom;
              -moz-transform-origin: bottom;
              -ms-transform-origin: bottom;
              -o-transform-origin: bottom;
              transform-origin: bottom;
            }
            li:hover:before {
              opacity: 1;
            }
            .select {
              -webkit-transform: scale(1.1);
              -moz-transform: scale(1.1);
              -ms-transform: scale(1.1);
              -o-transform: scale(1.1);
              transform: scale(1.1);
              -webkit-transform-origin: bottom;
              -moz-transform-origin: bottom;
              -ms-transform-origin: bottom;
              -o-transform-origin: bottom;
              transform-origin: bottom;
            }
            .select:before {
              opacity: 1;
            }
          }
        }
        .photo_list_frame::-webkit-scrollbar {
          height: 0px;
        }
        .look_swiper_arrow {
          width: 70px;
          height: 70px;
          background-color: #fff;
          position: absolute;
          top: 0;
          bottom: 0;
          margin: auto;
          cursor: pointer;
          z-index: 100;
          text-align: center;
          font-size: 50px;
          line-height: 70px;
          // transition: all .3s;
          // &:hover {
          //   background-color: grey;
          // }
        }
        .look_swiper_prev {
          left: -80px;
        }
        .look_swiper_next {
          right: -80px;
        }

        .look_swiper_prev:before {
          background-position: -23px -18px;
        }
        .look_swiper_next:before {
          background-position: -65px -18px;
        }
      }
    }
  }
}

.mb_pattern .basic_atlas_catalog_pc_look {
  background: rgba(0, 0, 0, 1);
  /deep/ .el-dialog {
    .look_frame {
      padding: 0;
      .close_look {
        top: 0;
        right: 0;
        padding: 10px;
        font-size: 30px;
      }
      .look_swiper {
        .mb_title {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          padding: 20px;
          background: 0 0;
          color: #fff;
          font-size: 14px;
          line-height: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .back_img {
          width: 100%;
          img {
            max-width: 100%;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/atlas_look/pc_look.vue